export default "__VITE_ASSET__7eada427__"